<template>
  <div id='unit-convert'>
      <div style="text-align: center;font-weight: 700;margin:20px 0;">
        <p>热通量密度单位换算</p>
      </div>
      <div id="unquickcalc" style="display:none;"></div>
      <div id="ucresult" class="ucresulttext"></div>
      <form>
        <table id="uctable">
            <tr>
                <td class="uccell">
                    <label for="ucfrom">From:</label>
                    <br>
                    <input type="text" name="ucfrom" class="ucinput" id="ucfrom" onKeyUp="ucUpdateResult();" autofocus>
                </td>
                <td class="uccell">
                    <label for="ucto">To:</label>
                    <br>
                    <input type="text" name="ucto" class="ucinput" id="ucto" style="background-color:#eeeeee;" readonly>
                </td>
            </tr>
            <tr>
                <td class="uccell">
                  <select name="ucfromunit" id="ucfromunit" size="15" onChange="ucUpdateResult();" class="ucselect">
                    <option value="watt/square meter [W/m^2] [1000000]" selected>watt/square meter [W/m^2]</option>
                    <option value="kilowatt/square meter [1000]">kilowatt/square meter</option>
                    <option value="watt/square centimeter [100]">watt/square centimeter</option>
                    <option value="watt/square inch [W/in^2] [645.1599995]">watt/square inch [W/in^2]</option>
                    <option value="joule/second/square meter [1000000]">joule/second/square meter</option>
                    <option value="kilocalorie (IT)/hour/square meter [859845.2279]">kilocalorie (IT)/hour/square meter</option>
                    <option value="kilocalorie (IT)/hour/square foot [79882.23556]">kilocalorie (IT)/hour/square foot</option>
                    <option value="calorie (IT)/second/square centimeter [23.88458966]">calorie (IT)/second/square centimeter</option>
                    <option value="calorie (IT)/minute/square centimeter [1433.0753796]">calorie (IT)/minute/square centimeter</option>
                    <option value="calorie (IT)/hour/square centimeter [85984.52278]">calorie (IT)/hour/square centimeter</option>
                    <option value="calorie (th)/second/square centimeter [23.9005736138]">calorie (th)/second/square centimeter</option>
                    <option value="calorie (th)/minute/square centimeter [1434.03441683]">calorie (th)/minute/square centimeter</option>
                    <option value="calorie (th)/hour/square centimeter [86042.0650098]">calorie (th)/hour/square centimeter</option>
                    <option value="dyne/hour/centimeter [3600000000000]">dyne/hour/centimeter</option>
                    <option value="erg/hour/square millimeter [36000000000]">erg/hour/square millimeter</option>
                    <option value="foot pound/minute/square foot [4111305.952]">foot pound/minute/square foot</option>
                    <option value="horsepower/square foot [124.5850288]">horsepower/square foot</option>
                    <option value="horsepower (metric)/square foot [126.3129815]">horsepower (metric)/square foot</option>
                    <option value="Btu (IT)/second/square foot [88.0550918412]">Btu (IT)/second/square foot</option>
                    <option value="Btu (IT)/minute/square foot [5283.305459]">Btu (IT)/minute/square foot</option>
                    <option value="Btu (IT)/hour/square foot [316998.330628]">Btu (IT)/hour/square foot</option>
                    <option value="Btu (th)/second/square inch [0.611902914742]">Btu (th)/second/square inch</option>
                    <option value="Btu (th)/second/square foot [88.1140197229]">Btu (th)/second/square foot</option>
                    <option value="Btu (th)/minute/square foot [5286.84118337]">Btu (th)/minute/square foot</option>
                    <option value="Btu (th)/hour/square foot [317210.471002]">Btu (th)/hour/square foot</option>
                    <option value="CHU/hour/square foot [176110.1819]">CHU/hour/square foot</option>
                </select>
                </td>
                <td class="uccell">
                  <select name="uctounit" id="uctounit" size="15" onChange="ucUpdateResult();" class="ucselect">
                    <option value="watt/square meter [W/m^2] [1000000]">watt/square meter [W/m^2]</option>
                    <option value="kilowatt/square meter [1000]" selected>kilowatt/square meter</option>
                    <option value="watt/square centimeter [100]">watt/square centimeter</option>
                    <option value="watt/square inch [W/in^2] [645.1599995]">watt/square inch [W/in^2]</option>
                    <option value="joule/second/square meter [1000000]">joule/second/square meter</option>
                    <option value="kilocalorie (IT)/hour/square meter [859845.2279]">kilocalorie (IT)/hour/square meter</option>
                    <option value="kilocalorie (IT)/hour/square foot [79882.23556]">kilocalorie (IT)/hour/square foot</option>
                    <option value="calorie (IT)/second/square centimeter [23.88458966]">calorie (IT)/second/square centimeter</option>
                    <option value="calorie (IT)/minute/square centimeter [1433.0753796]">calorie (IT)/minute/square centimeter</option>
                    <option value="calorie (IT)/hour/square centimeter [85984.52278]">calorie (IT)/hour/square centimeter</option>
                    <option value="calorie (th)/second/square centimeter [23.9005736138]">calorie (th)/second/square centimeter</option>
                    <option value="calorie (th)/minute/square centimeter [1434.03441683]">calorie (th)/minute/square centimeter</option>
                    <option value="calorie (th)/hour/square centimeter [86042.0650098]">calorie (th)/hour/square centimeter</option>
                    <option value="dyne/hour/centimeter [3600000000000]">dyne/hour/centimeter</option>
                    <option value="erg/hour/square millimeter [36000000000]">erg/hour/square millimeter</option>
                    <option value="foot pound/minute/square foot [4111305.952]">foot pound/minute/square foot</option>
                    <option value="horsepower/square foot [124.5850288]">horsepower/square foot</option>
                    <option value="horsepower (metric)/square foot [126.3129815]">horsepower (metric)/square foot</option>
                    <option value="Btu (IT)/second/square foot [88.0550918412]">Btu (IT)/second/square foot</option>
                    <option value="Btu (IT)/minute/square foot [5283.305459]">Btu (IT)/minute/square foot</option>
                    <option value="Btu (IT)/hour/square foot [316998.330628]">Btu (IT)/hour/square foot</option>
                    <option value="Btu (th)/second/square inch [0.611902914742]">Btu (th)/second/square inch</option>
                    <option value="Btu (th)/second/square foot [88.1140197229]">Btu (th)/second/square foot</option>
                    <option value="Btu (th)/minute/square foot [5286.84118337]">Btu (th)/minute/square foot</option>
                    <option value="Btu (th)/hour/square foot [317210.471002]">Btu (th)/hour/square foot</option>
                    <option value="CHU/hour/square foot [176110.1819]">CHU/hour/square foot</option>
                </select>
                </td>
            </tr>
        </table>
    </form>
  </div>
</template>
<script>
export default {
  mounted(){
  }
}
</script>
<style scoped>
#unit-convert{
  height: calc(100vh - 125px);
}
</style>
